import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NgService } from '../../core/ng.service';
import { SidePanelService } from '../core/side-panel.service';
import { SidePanelStateComponent } from '../shared/side-panel-state-component';
import { SidePanelState } from '../shared/sidePanelStates/side-panel-state';
import { SidePanelMainContentDirective } from './side-panel-main-content.directive';

@Component({
  selector: 'rl-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit {
  @ViewChild(SidePanelMainContentDirective, { static: true }) mainContent: SidePanelMainContentDirective;

  currentState: SidePanelState;

  open: boolean = true;

  constructor(private sidePanelService: SidePanelService, private element: ElementRef, private viewContainerRef: ViewContainerRef, private ngJsService: NgService) {}

  ngOnInit(): void {
    this.sidePanelService.sidePanelState$.subscribe((newState) => this.refreshState(newState));
    this.sidePanelService.sidePanelDisplay$.subscribe((display: boolean) => (display ? this.show() : this.hide()));
  }

  refreshState(state: SidePanelState): void {
    this.currentState = state;
    this.ngJsService.setNgAsideOn(true);
    // if(!this.open){
    //   this.show();
    //   this.open = false;
    // }
    this.loadState();
  }

  loadState() {
    const viewContainerRef = this.mainContent.container;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<SidePanelStateComponent>(this.currentState.component);
    componentRef.instance.data = this.currentState.data;
    componentRef.instance.exit = () => {
      this.sidePanelService.clear();
      !this.open && this.hide();
    };
  }

  show() {
    this.open = true;
    this.ngJsService.setNgAsideOn(this.open);
  }

  hide() {
    this.open = false;
    this.ngJsService.setNgAsideOn(this.open);
  }
}
